let reasons = ['cannibalized', 'euthanized', 'found dead'];
export {reasons}